import React from 'react';

export default ({ status, color, width, height }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        backgroundColor: color,
        borderRadius: '5px',
        color: 'white',
        display: 'flex',
        fontSize: '12px',
        fontWeight: '500',
        height: height || '25px',
        justifyContent: 'center',
        width: width || '110px',
      }}>
      {status}
    </div>
  );
};
